<template>
  <div class="invoice-rest">
    <div class="invoice-rest-tip">
      <span>温馨提示：</span>
      <span>请及时更新发票余量，以免影响客户选择贵司开展业务</span>
    </div>
    <div class="invoice-rest-form">
      <span class="form-title">发票余量</span>
      <el-form ref="form" label-width="130px" size="small" :model="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="月份" prop="time">
              <el-date-picker v-model="form.time" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票余量是否充足" prop="enough">
              <el-select v-model="form.enough">
                <el-option v-for="(item, index) in applyStatusAll" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item style="margin-bottom: 0px; text-align: right;">
              <el-button @click="resetForm()">重置</el-button>
              <el-button type="primary" @click="submitForm()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="invoice-rest-opea">
      <el-button size="small" @click="setAmount()">新增余量记录</el-button>
    </div>
    <el-table>
      <el-table-column prop="invoiceApplyNo" label="月份" width="150"> </el-table-column>
      <el-table-column prop="invoiceClass" label="发票总余量（张）"> </el-table-column>
      <el-table-column prop="invoiceApplyStatus" label="可开票总金额（元）"> </el-table-column>
      <el-table-column prop="applyTime" label="发票余量是否充足"> </el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="新增时间" width="160"></el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="更新" width="160"></el-table-column>
      <el-table-column fixed="right" label="操作" width="80">
        <template>
          <el-button type="text" size="small">更新余量</el-button>
        </template>
      </el-table-column>
    </el-table>

    <add-invoice-rest ref="invoceRef"></add-invoice-rest>
  </div>
</template>

<script>
import AddInvoiceRest from './components/addInvoiceRest';

export default {
  name: 'invoiceApply',
  components: {
    AddInvoiceRest,
  },
  data() {
    return {
      applyStatusAll: [],
      form: {
        time: '',
        enough: 0,
      },
      data: [],
    };
  },
  methods: {
    submitForm() {},
    resetForm() {
      this.$refs.form.resetFields();
    },
    setAmount() {
      this.$refs.invoceRef.show();
    },
    exportInfo() {},
  },
};
</script>

<style lang="less" scoped>
.invoice-rest {
  .invoice-rest-tip {
    padding: 8px 12px;
    border: 1px solid #ffcd61;
    color: rgba(0, 0, 0, 0.65);
    background-color: #fffcf2;
    margin-bottom: 24px;
    > span {
      display: block;
    }
  }
  .invoice-rest-form {
    border: 1px solid #ebeef5;
    padding: 16px;
    .form-title {
      font-size: 16px;
      font-weight: 700;
      color: #050505;
      margin-bottom: 20px;
      display: block;
    }
  }
  .invoice-rest-opea {
    padding: 16px 0px;
    text-align: right;
  }
  /deep/ .el-date-editor--daterange.el-input__inner {
    width: 100%;
  }
  /deep/ .el-select {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/invoiceRest.vue